import './App.css';
import Temp from './components/Tempapp'

function App() {
  return (
    <div className="App">
      <Temp />
    </div>
  );
}

export default App;
